import React, { useEffect, useRef, useState, FC } from 'react'
import { Button, Form, Input, message, Modal, notification, Radio } from 'antd'
import { YhFormBox } from '@/components/YhFormBox'
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, IYhFormRef, ISelectOption } from '@/components/YhFormBox/Types'
import useNavModel, { RouterParamType } from '@/model/navModel'
import { getFormValidatorErrText } from '@/utils/utils'
import { globalPrompt } from '@/components/message'
import { DictCodeEnmu } from '@/types/ScmDictEnums'
import { useSupplierDetailsMode } from './supplierDetailsModel'
import { ISupplierFormFields, keyFocusAreasOptions, partsDemandLevelOptions, repairQualificationOptions, siteConditionSummaryOptions } from '../../supplierTypes'
import { debounce } from 'lodash'
import { supplierCategoryOption, supplierEnterpriseNatureOption, supplierTypeOption } from '@/types/supplierDs'
import { SupplierDictCodeEnmu } from '@/types/supplierDictEnums'

export const BaseInfo: FC<RouterParamType> = ({ id, mode }) => {
    const formRef = useRef<IYhFormRef>()
    const { editFormVal, addFormVal, updateAddFormVal, updateEditFormVal } = useSupplierDetailsMode()
   

    //保留缓存及回显表单
    const saveCache = (val: { [key: string]: any }, isFormItem: boolean = true) => {
        mode === 'edit' ? updateEditFormVal(val) : updateAddFormVal(val)
    }

    //表单change
    const onChange = (changedValues: { [key: string]: any }, values: ISupplierFormFields) => {
        saveCache(changedValues)
    }

    let newFormVal = mode === 'edit' ? editFormVal : addFormVal


    useEffect(()=>{
        if(mode === 'add'){
            if(addFormVal.type === SupplierDictCodeEnmu.SUPPLIER_TYPE_WORKINGHOURS){//工时
                setUseForm(baseFormItemForManHour)
            }else{
                setUseForm(baseFormItem)
            }
        }

        if(mode === 'edit'){
            if(editFormVal.type === SupplierDictCodeEnmu.SUPPLIER_TYPE_WORKINGHOURS){//工时
                setUseForm(baseFormItemForManHour)
            }else{
                setUseForm(baseFormItem)
            }
        }

    },[ addFormVal.type, editFormVal.type])

    const baseFormItem: IYhFormItemsBox = {
        contentClass: 'pr-77',
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '主营产品',
                fieldName: 'mainProductIntroduction',
                placeholder: '主营产品',
                span: 12,
            },
        ],
    }

    const baseFormItemForManHour: IYhFormItemsBox = {
        contentClass: 'pr-77',
        items: [
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: '维修资质',
                fieldName: 'repairQualification',
                placeholder: '维修资质',
                span: 6,
                options: repairQualificationOptions,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '维修人员',
                fieldName: 'repairPersonnel',
                placeholder: '维修人员',
                span: 6,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '维修场地',
                fieldName: 'siteCondition',
                placeholder: '维修场地',
                span: 6,
            },
             {
                type: FormItemTypeEnum.Input,
                fieldLabel: '仓库面积',
                fieldName: 'warehouseArea',
                placeholder: '仓库面积',
                span: 6,
            },
           
           
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: '配件需求量',
                fieldName: 'partsDemandLevel',
                placeholder: '配件需求量',
                span: 6,
                options: partsDemandLevelOptions,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '配件品牌',
                fieldName: 'partsBrands',
                placeholder: '配件品牌',
                span: 6,
            },
             {
                type: FormItemTypeEnum.Other,
                fieldLabel: '场地情况',
                fieldName: 'siteConditionSummary',
                placeholder: '场地情况',
                span: 12,
                formItem: (
                    <Form.Item name="siteConditionSummary"
                        label="场地情况" labelCol={{span:3}}>
                        <Radio.Group>
                            {
                                siteConditionSummaryOptions.map(i => {
                                    return <Radio value={i.value} key={i.key}>{i.label}</Radio>
                                })
                            }
                        </Radio.Group>
                    </Form.Item>
                ),
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '采购渠道',
                fieldName: 'purchaseChannel',
                placeholder: '采购渠道',
                span: 6,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '油品需求量',
                fieldName: 'oilDemand',
                placeholder: '油品需求量',
                span: 6,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '油品品牌',
                fieldName: 'oilBrands',
                placeholder: '油品品牌',
                span: 6,
            },
            {
                type: FormItemTypeEnum.Other,
                fieldLabel: '重点关注',
                fieldName: 'keyFocusAreas',
                placeholder: '重点关注',
                span: 12,
                 formItem: (
                    <Form.Item name="keyFocusAreas"
                        label="重点关注" labelCol={{span: 3}}>
                        <Radio.Group>
                            {
                                keyFocusAreasOptions.map(i => {
                                    return <Radio value={i.value} key={i.key}>{i.label}</Radio>
                                })
                            }
                        </Radio.Group>
                    </Form.Item>
                ),
            },
        ],
    }

     const [useForm, setUseForm] = useState<IYhFormItemsBox>(baseFormItemForManHour)

    const poFromConfig: IYhFormBox<ISupplierFormFields> = {
        formRef,
        labelCol: { span: 6 },
        labelAlign: 'right',
        formValues: mode === 'edit' ? editFormVal : addFormVal,
        onChange,
        // boxs: [baseFormItem],
        boxs: [useForm],
    }

    return <YhFormBox {...poFromConfig} />
}
